import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import api from "@/api/api";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutView',
  setup(__props) {

onMounted(async () => {
  const res = await api.auth.getLogoutUrl();
  window.location.href = res.url;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})